module.exports = __webpack_public_path__ + "static/media/Stellar King Drawer Bed Base - 180x210 cm.8de81c40.jpg";